<template>
  <component :is="tag">
    <a-menu
      auto-open-selected
      :mode="menuMode"
      :theme="theme"
      :collapsed="state.isCollapse"
      v-model:selected-keys="defaultSelectedPath"
      @menu-item-click="onMenuClick"
    >
      <template v-for="item of menuOptions" :key="item.key">
        <template v-if="item.children?.length">
          <sub-menu :key="item.key" :menu-info="item" />
        </template>
        <template v-else>
          <a-menu-item :key="item.key">
            <template #icon>
              <svg-icon v-if="item.icon" :name="item.icon" />
            </template>
            {{ item.label }}
          </a-menu-item>
        </template>
      </template>
    </a-menu>
  </component>
</template>

<script lang="ts">
  import { computed, defineComponent, PropType, ref, shallowReactive, watch, watchEffect } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useLayoutStore } from '../../index'
  import { isExternal, transfromMenu } from '../../../utils'

  export default defineComponent({
    name: 'ScrollerMenu',
    props: {
      routes: {
        type: Array as PropType<Array<RouteRecordRawWithHidden>>,
        require: true,
        default: () => [],
      },
      mode: {
        type: String as PropType<'horizontal' | 'vertical' | 'pop' | 'popButton'>,
        default: 'vertical',
      },
    },
    setup(props) {
      const store = useLayoutStore()
      const menuOptions = shallowReactive([] as Array<any>)
      const defaultSelectedPath = ref([] as Array<string>)
      const defaultExpandKeys = ref([] as Array<string>)
      const menuMode = computed(() => props.mode)
      const currentRoute = useRoute()
      const router = useRouter()
      const tag = ref(menuMode.value === 'vertical' ? 'Scrollbar' : 'div')
      const theme = computed(() => {
        if (store.state.theme === 'dark') {
          return 'dark'
        }
        if (store.state.layoutMode === 'ttb') {
          return 'light'
        }
        return store.state.sideBarBgColor === 'image'
          ? 'dark'
          : store.state.sideBarBgColor === 'white'
          ? 'light'
          : 'dark'
      })

      function handleMenu(routes?: Array<RouteRecordRawWithHidden>) {
        // 构建菜单
        menuOptions.length = 0
        const tempMenus = transfromMenu(routes || [])
        menuOptions.push(...tempMenus)
      }

      function onMenuClick(key: string) {
        if (isExternal(key)) {
          window.open(key)
        } else {
          router.push(key)
          if (store.state.device === 'mobile') {
            store.toggleCollapse(true)
          }
        }
      }

      watch(
        () => currentRoute,
        newVal => {
          defaultSelectedPath.value.length = 0
          defaultSelectedPath.value.push(newVal.path)
        },
        { immediate: true, deep: true }
      )
      watch(
        () => props.mode,
        newVal => {
          newVal === 'vertical' ? 'Scrollbar' : 'div'
        }
      )
      watchEffect(() => {
        handleMenu(props.routes)
      })

      return {
        tag,
        theme,
        menuMode,
        defaultSelectedPath,
        defaultExpandKeys,
        state: store?.state,
        menuOptions,
        onMenuClick,
      }
    },
  })
</script>

<style lang="less" scoped>
  :deep(.arco-menu-collapsed) {
    margin: 0 auto;
  }
  :deep(.arco-menu-vertical .arco-menu-item) {
    max-height: 40px;
  }
  .scrollbar {
    height: calc(100vh - @logoHeight) !important;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
</style>
